import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';
import Cheque from "./Cheque";
import ChequeInfo from "./ChequeInfo";
import DatePicker from 'react-datepicker2';
import ImportExcel from "../ImportExcel";

export default class Cheques extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'cheque',
            type: props.Type,
            data: null,
            loading: true,
            filters: {
                type: props.Type,
                bank: '',
                branch: '',
                sayyadi: '',
                fromDate: '',
                toDate: '',
                fromDateConverted: '',
                toDateConverted: '',
            },
            systemModuleId: 7,
            moduleAccessStatus: 1,
            page: 1,
            per_page: 30,
            phrase: '',
            menuId: 0
        };
        this.resetFilters(props.Type);
        this.setMenuId(this.state.filters.type);
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    setMenuId(type) {
        if (type === 1) this.state.menuId = 43;
        if (type === 2) this.state.menuId = 44;
    }
    resetFilters(type) {
        this.state.filters = {
            type: type,
            bank: '',
            branch: '',
            sayyadi: '',
            fromDate: '',
            toDate: '',
            fromDateConverted: '',
            toDateConverted: '',
            status: 0,
            fromPrice: '',
            toPrice: '',
            guarantee: 0,
            firstAnnual: 0,
            toPersonName: ''
        };
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;

                this.refreshData();
            });
    }
    componentWillReceiveProps(props) {
        if (props.Type == this.state.filters.type) return;
        this.resetFilters(props.Type);
        this.setMenuId(this.state.filters.type);
        this.refreshData();
    }
    change(id, status) {
        this.removeKeyDown();
        this.showComponents({ component: <Cheque Type={this.state.type} Caller={this} Id={id} Status={status} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <ChequeInfo Type={this.state.type} Caller={this} Id={this.getDefaultGuid()} /> });
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <ChequeInfo Type={this.state.type} Caller={this} Id={id} /> });
    }
    onImport() {
        this.removeKeyDown();
        if (this.state.type === 1)
            this.showComponents({ component: <ImportExcel Caller={this} Type={15} CompanyId={this.state.data.global.company.id} /> });
        if (this.state.type === 2)
            this.showComponents({ component: <ImportExcel Caller={this} Type={16} CompanyId={this.state.data.global.company.id} /> });
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            {this.state.filters.type === 1 && <h3 className="nk-block-title page-title">فهرست چکهای دریافتی</h3>}
                            {this.state.filters.type === 2 && <h3 className="nk-block-title page-title">فهرست چکهای پرداختی </h3>}
                            <div className="nk-block-des text-soft">
                                <p>{this.money(this.state.data.recordsCount)} چک یافت شد</p>
                            </div>
                        </div>
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        <li>
                                            <li>
                                                <a className="hand btn btn-primary" onClick={e => this.onAdd()}>ابتدای دوره</a>
                                            </li>
                                            <li>
                                                <a onClick={e => this.onImport()} className="btn-sm hand btn btn-success"><span>ورود اکسل ابتدای دوره</span></a>
                                            </li>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner-group">
                            <div className="card-inner position-relative card-tools-toggle">
                                <div className="card-title-group">
                                    <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                        <div className="form-inline flex-nowrap gx-3">
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.phrase} onChange={e => this.state.phrase = e.target.value} placeholder="شماره چک" className="form-control" />
                                            </div>
                                            {this.state.filters.type === 1 && <div className="form-wrap">
                                                <input defaultValue={this.state.filters.toPersonName} onChange={e => this.state.filters.toPersonName = e.target.value} type="text" className="form-input" placeholder="شخص واگذار شده" />
                                            </div>}
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.filters.sayyadi} onChange={e => this.state.filters.sayyadi = e.target.value} placeholder="شماره صیادی" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.filters.bank} onChange={e => this.state.filters.bank = e.target.value} placeholder="بانک" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.filters.branch} onChange={e => this.state.filters.branch = e.target.value} placeholder="شعبه" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <select defaultValue={this.state.filters.status} onChange={e => this.state.filters.status = parseInt(e.target.value)} className="form-control">
                                                    <option value="0">همه وضعیتها</option>
                                                    <option value="1">ثبت اولیه</option>
                                                    {this.state.filters.type === 1 && <option value="2">واگذار شده</option>}
                                                    {this.state.filters.type === 1 && <option value="3">وصول شده</option>}
                                                    {this.state.filters.type === 1 && <option value="5">عودتی</option>}
                                                    {this.state.filters.type === 1 && <option value="6">سرحساب</option>}
                                                    {this.state.filters.type === 2 && <option value="4">برگشتی</option>}
                                                    {this.state.filters.type === 2 && <option value="7">پاس شده</option>}
                                                </select>
                                            </div>
                                            <div className="form-wrap">
                                                <select defaultValue={this.state.filters.guarantee} onChange={e => this.state.filters.guarantee = parseInt(e.target.value)} className="form-select">
                                                    <option value="0">همه چکها</option>
                                                    <option value="1">معاملاتی</option>
                                                    <option value="2">ضمانتی</option>
                                                </select>
                                            </div>
                                            <div className="form-wrap">
                                                <select defaultValue={this.state.filters.firstAnnual} onChange={e => this.state.filters.firstAnnual = parseInt(e.target.value)} className="form-select">
                                                    <option value="0">همه چکها</option>
                                                    <option value="1">ابتدای دوره ای</option>
                                                    <option value="2">طی دوره ای</option>
                                                </select>
                                            </div>
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.filters.fromPrice} onChange={e => this.state.filters.fromPrice = e.target.value} placeholder="از مبلغ" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.filters.toPrice} onChange={e => this.state.filters.toPrice = e.target.value} placeholder="تا مبلغ" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <DatePicker
                                                    inputReadOnly={false}
                                                    className="form-control persian-date ltr"
                                                    placeholder={"از تاریخ"}
                                                    isGregorian={false}
                                                    showTodayButton={true}
                                                    timePicker={false}
                                                    onChange={(e) => {
                                                        this.state.filters.fromDate = e;
                                                        this.state.filters.fromDateConverted = this.convertMomentToDb(e)
                                                    }}
                                                    value={this.getFormatedDateForDatePicker(this.state.filters.fromDate)}
                                                />
                                            </div>
                                            <div className="form-wrap">
                                                <DatePicker
                                                    inputReadOnly={false}
                                                    className="form-control persian-date ltr"
                                                    placeholder={"تا تاریخ"}
                                                    isGregorian={false}
                                                    showTodayButton={true}
                                                    timePicker={false}
                                                    onChange={(e) => {
                                                        this.state.filters.toDate = e;
                                                        this.state.filters.toDateConverted = this.convertMomentToDb(e)
                                                    }}
                                                    value={this.getFormatedDateForDatePicker(this.state.filters.toDate)}
                                                />
                                            </div>
                                            <div className="btn-wrap">
                                                <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em class="icon ni ni-search"></em> جستجو</button></span>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            {this.state.data.recordsCount <= 0 ?
                                <div className="card-inner-group">
                                    <div className="example-alert">
                                        <div className="alert alert-pro alert-warning">
                                            <div className="alert-text">
                                                <h6>توجه</h6>
                                                <p>هیچ چکی یافت نشد</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="card-inner p-0">
                                    <div className="nk-tb-list nk-tb-ulist">
                                        <div className="nk-tb-item nk-tb-head">
                                            <div className="nk-tb-col text-center"><span className="sub-text">شماره چک</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">شماره صیادی</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">وضعیت</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">ضمانتی</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">مبلغ</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">تاریخ</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">{(this.state.filters.type === 1 ? "دریافت از" : "پرداخت به")}</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">بانک</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">شعبه</span></div>
                                            {this.state.filters.type === 1 && <div className="nk-tb-col text-center"><span className="sub-text">واگذار به</span></div>}
                                            <div className="nk-tb-col text-center"><span className="sub-text">عملیات</span></div>
                                            <div className="nk-tb-col text-end"><span className="sub-text"></span></div>
                                        </div>
                                        {this.state.data.records.map((record, index) =>
                                            <div className="nk-tb-item">
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">
                                                        {record.number}
                                                    </span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.sayyadi}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.statusString}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.guarantee ? "بله" : "خیر"}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{this.money(record.price)}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.chequeDateString}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    {this.state.filters.type === 1 ?
                                                        <span className="sub-text text-center">{record.fromPersonName}</span>
                                                        :
                                                        <span className="sub-text text-center">{record.toPersonName}</span>
                                                    }
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.bankName}</span>
                                                </div>
                                                {this.state.filters.type === 1 && <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.toPersonName}</span>
                                                </div>}                                                
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.branch}</span>
                                                </div>
                                                <div className="nk-tb-col nk-tb-col-tools">
                                                    <ul className="nk-tb-actions gx-1">
                                                        <li>
                                                            <div className="drodown">
                                                                <a href="#" className="dropdown-toggle btn btn-icon btn-trigger" data-bs-toggle="dropdown"><em className="icon ni ni-more-h"></em></a>
                                                                <div className="dropdown-menu dropdown-menu-end">
                                                                    <ul className="link-list-opt no-bdr">
                                                                        <li>
                                                                            {this.state.filters.type === 1 && [
                                                                                record.status === 1 && <a className="text-warning txt-bold hand" onClick={e => this.change(record.id, 2)}>واگذاری</a>
                                                                                ,
                                                                                record.status === 1 && <a className="text-success txt-bold hand" onClick={e => this.change(record.id, 8)}>وصول</a>
                                                                                ,
                                                                                record.status === 6 && <a className="text-success txt-bold hand" onClick={e => this.change(record.id, 3)}>وصول</a>
                                                                                ,
                                                                                (record.status === 6 || record.status === 1) && <a className="text-danger txt-bold hand" onClick={e => this.change(record.id, 5)}>عودت</a>
                                                                                ,
                                                                                record.status === 1 && <a className="text-primary txt-bold hand" onClick={e => this.change(record.id, 6)}>سرحساب</a>
                                                                            ]}
                                                                            {this.state.filters.type === 2 && record.status === 1 && [
                                                                                <a className="text-danger txt-bold hand" onClick={e => this.change(record.id, 4)}> برگشتی</a>
                                                                                ,
                                                                                <a className="text-success txt-bold hand" onClick={e => this.change(record.id, 7)}> پاس</a>
                                                                            ]}
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="nk-tb-col nk-tb-col-tools">
                                                    <ul className="nk-tb-actions gx-1">
                                                        <li>
                                                            <div className="drodown">
                                                                <a href="#" className="dropdown-toggle btn btn-icon btn-trigger" data-bs-toggle="dropdown"><em className="icon ni ni-more-h"></em></a>
                                                                <div className="dropdown-menu dropdown-menu-end">
                                                                    <ul className="link-list-opt no-bdr">
                                                                        <li>
                                                                            {record.status === 1 && <a className="hand" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف رکورد">
                                                                                <em className="icon ni ni-cross-fill-c"></em> حذف
                                                                            </a>}
                                                                            {record.canModify && <a className="hand text-primary mx-1" onClick={e => this.onEdit(record.id)} title="ویرایش">
                                                                                <em className="icon ni ni-pen"></em>
                                                                            </a>}
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            }
                            {this.createPaging()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                this.renderPopupComponent(),
                <Footer />
            ];
        return contents;
    }
}